<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/account"></ion-back-button>
    </ion-buttons>
    <ion-title>Administration</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content color="lightmimbo">
  <ion-grid>
    <ion-row>
      <ion-col sizeXl="10" offsetXl="1">
        <ion-list class="settings-list ion-no-padding">
          <ion-item detail routerLink="notifications" color="lightmimbo"><ion-icon name="notifications-outline"
              class="ion-item-left ion-margin-end"></ion-icon><ion-label>Send Notification</ion-label></ion-item>
          <ion-item detail routerLink="facts" articleInDB.AddedBy="updateArticleDTO.addedBy;"
            color="lightmimbo"><ion-icon name="reader-outline"
              class="ion-item-left ion-margin-end"></ion-icon><ion-label>Daily Facts</ion-label></ion-item>
          <ion-item detail routerLink="articles" color="lightmimbo"><ion-icon name="notifications-outline"
              class="ion-item-left ion-margin-end"></ion-icon>
            <ion-label>Articles</ion-label></ion-item>
          <ion-item detail routerLink="exercises" color="lightmimbo"><ion-icon name="tennisball-outline"
              class="ion-item-left ion-margin-end"></ion-icon><ion-label>Exercises</ion-label></ion-item>
          <ion-item detail routerLink="recipes" color="lightmimbo"><ion-icon name="fast-food-outline"
              class="ion-item-left ion-margin-end"></ion-icon><ion-label>Recipes</ion-label></ion-item>
          <ion-item detail routerLink="reports" color="lightmimbo"><ion-icon name="nuclear-outline"
              class="ion-item-left ion-margin-end"></ion-icon><ion-label>Reported Data</ion-label></ion-item>
        </ion-list>
      </ion-col></ion-row></ion-grid>
</ion-content>